export const mimeTypes = {
	'audio/aac': 'aac',
	'application/x-abiword': 'abw',
	'application/x-freearc': 'arc',
	'image/avif': 'avif',
	'video/x-msvideo': 'avi',
	'application/vnd.amazon.ebook': 'azw',
	'application/octet-stream': 'bin',
	'image/bmp': 'bmp',
	'application/x-bzip': 'bz',
	'application/x-bzip2': 'bz2',
	'application/x-cdf': 'cda',
	'application/x-csh': 'csh',
	'text/css': 'css',
	'text/csv': 'csv',
	'application/msword': 'doc',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
		'docx',
	'application/vnd.ms-fontobject': 'eot',
	'application/epub+zip': 'epub',
	'application/gzip': 'gz',
	'image/gif': 'gif',
	'text/html': 'html',
	'image/vnd.microsoft.icon': 'ico',
	'image/x-icon': 'ico',
	'image/ico': 'ico',
	'image/icon': 'ico',
	'text/ico': 'ico',
	'application/ico': 'ico',
	'text/calendar': 'ics',
	'application/java-archive': 'jar',
	'image/jpeg': 'jpeg',
	'text/javascript': 'js',
	'application/json': 'json',
	'application/ld+json': 'jsonld',
	'audio/midi': 'midi',
	'audio/x-midi': 'midi',
	'audio/mpeg': 'mp3',
	'video/mp4': 'mp4',
	'video/mpeg': 'mpeg',
	'video/quicktime': 'mov',
	'audio/ogg': 'oga',
	'video/ogg': 'ogv',
	'audio/opus': 'opus',
	'application/vnd.apple.installer+xml': 'mpkg',
	'application/vnd.oasis.opendocument.presentation': 'odp',
	'application/vnd.oasis.opendocument.spreadsheet': 'ods',
	'application/vnd.oasis.opendocument.text': 'odt',
	'application/ogg': 'ogx',
	'font/otf': 'otf',
	'image/png': 'png',
	'application/pdf': 'pdf',
	'application/x-httpd-php': 'php',
	'application/vnd.ms-powerpoint': 'ppt',
	'application/vnd.openxmlformats-officedocument.presentationml.presentation':
		'pptx',
	'application/vnd.ms-powerpoint.presentation.macroEnabled.12': 'pptm',
	'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
		'ppsx',
	'application/vnd.ms-powerpoint.slideshow': 'pps',
	'application/vnd.rar': 'rar',
	'application/rtf': 'rtf',
	'application/x-sh': 'sh',
	'image/svg+xml': 'svg',
	'application/x-tar': 'tar',
	'image/tiff': 'tiff',
	'video/mp2t': 'ts',
	'font/ttf': 'ttf',
	'text/plain': 'txt',
	'application/vnd.visio': 'vsd',
	'audio/wav': 'wav',
	'audio/webm': 'weba',
	'video/webm': 'webm',
	'image/webp': 'webp',
	'font/woff': 'woff',
	'font/woff2': 'woff2',
	'application/xhtml+xml': 'xhtml',
	'application/vnd.ms-excel': 'xls',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
	'application/xml': 'xml',
	'application/atom+xml': 'xml',
	'.xml': 'xml',
	'text/xml': 'xml',
	'application/vnd.mozilla.xul+xml': 'xul',
	'application/zip': 'zip',
	'video/3gpp': '3gp',
	'audio/3gpp': '3gp',
	'audio/3gpp2': '3g2',
	'video/3gpp2': '3g2',
	'application/x-7z-compressed': '7z',
};

export const defaultAllowedImageTypes = [
	'jpeg',
	'jpg',
	'png',
	'svg',
	'gif',
	'webp',
	'ico',
	'tiff',
	'tif',
	'bmp',
	'heif',
];
export const defaultAllowedFileTypes = [];

export const getAllowedFileTypes = (fileTypes) => {
	// console.log("getAllowedFileTypes input:", fileTypes);

	const fileTypesObject = {
		mimeTypes: {},
		types: [],
	};

	let filesMapArray = defaultAllowedFileTypes;

	if (fileTypes && Array.isArray(fileTypes) && fileTypes.length > 0) {
		let typesArray = [];
		typesArray = fileTypes.map((types) =>
			types && types.charAt(0) === '.' ? types.substring(1) : types,
		);
		filesMapArray = typesArray;
	} else if (fileTypes && Object.keys(fileTypes).length > 0) {
		const typesArray = [];
		// Process the fileTypes object to extract all allowed types
		Object.keys(fileTypes).forEach((type) => {
			if (Array.isArray(fileTypes[type])) {
				// For each file extension in the array
				fileTypes[type].forEach((ext) => {
					// Remove leading dot if present
					const cleanExt = ext.charAt(0) === '.' ? ext.substring(1) : ext;
					// Add to our types array
					typesArray.push(cleanExt);
				});
			}
		});

		filesMapArray = typesArray;
		// console.log("Processed file types:", filesMapArray);
	}

	fileTypesObject.types = filesMapArray;

	// Map MIME types to file extensions
	Object.keys(mimeTypes).forEach((mime) => {
		const mimeExt = mimeTypes[mime];

		// Check if this MIME type's extension is in our allowed list
		if (
			filesMapArray.includes(mimeExt) ||
			// Special case for jpeg/jpg which are often used interchangeably
			(mime === 'image/jpeg' &&
				(filesMapArray.includes('jpg') || filesMapArray.includes('jpeg')))
		) {
			const value = [];
			value.push(`.${mimeExt}`);

			// Add common alternatives
			if (mime === 'application/msword') {
				value.push('.docx');
			}
			if (mime === 'image/jpeg') {
				value.push('.jpg');
				value.push('.jpeg');
			}
			if (mime === 'image/tiff') {
				value.push('.tif');
			}

			fileTypesObject.mimeTypes[mime] = value;
		}
	});

	// console.log("Final allowedFileTypes:", fileTypesObject);
	return fileTypesObject;
};
